import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-preventie-si-stil-de-viata-sanatos',
  templateUrl: './preventie-si-stil-de-viata-sanatos.component.html',
  styleUrls: ['./preventie-si-stil-de-viata-sanatos.component.scss']
})
export class PreventieSiStilDeViataSanatosComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
